const lazyImage = {
  mounted: (el: HTMLImageElement) => {
    function loadImage() {
      if (el.dataset.url) {
        // el.addEventListener('load', onLoad); - extend logic if needed
        // el.addEventListener('error', onError); - extend logic if needed

        // eslint-disable-next-line no-param-reassign
        el.src = el.dataset.url;
      }
    }

    function handleIntersect(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadImage();
          observer.unobserve(el);
        }
      });
    }

    function createObserver() {
      const options: IntersectionObserverInit = {
        root: null,
        threshold: 0,
      };
      const observer = new IntersectionObserver(handleIntersect, options);
      observer.observe(el);
    }

    if (window.IntersectionObserver) {
      createObserver();
    } else {
      loadImage();
    }
  },

  unmounted: (el: HTMLImageElement) => {
    // el.removeEventListener('load', onLoad) - uncomment if extened loadImage logic
    // el.addEventListener('error', onError) - uncomment if extened loadImage logic
  },

};

export default lazyImage;
